module.exports = __webpack_public_path__ + "static/media/Caleb_Harper_mobile.3433b65f.jpg";